export default {
  USAF: {
    ranks: [
      'Gen',
      'Lt Gen',
      'Maj Gen',
      'Brig Gen',
      'Col',
      'Lt Col',
      'Maj',
      'Capt',
      '1st Lt',
      '2nd Lt',
      'CWO4',
      'CWO3',
      'CWO2',
      'WO1',
    ],
    components: ["ANG", "USAF", "USAFR"],
  },
  USA: {
    ranks: [
      'GEN',
      'LTG',
      'MG',
      'BG',
      'COL',
      'LTC',
      'MAJ',
      'CPT',
      '1LT',
      '2LT',
      'CW5',
      'CW4',
      'CW3',
      'CW2',
      'WO1',
    ],
    components: ['ARNG', 'USA', 'USAR'],
  },
  USCG: {
    ranks: [
      'ADM',
      'VADM',
      'RADM',
      'RDML',
      'CAPT',
      'CDR',
      'LCDR',
      'LT',
      'LTJG',
      'ENS',
      'CWO4',
      'CWO3',
      'CWO2',
      'WO1',
    ],
    components: ['USCG', 'USCGR'],
  },
  NOAA: {
    ranks: [
      'RADM',
      'RADM',
      'CAPT',
      'CDR',
      'LCDR',
      'LT',
      'LTJG',
      'ENS',
    ],
    components: ['NOAA'],
  },
  USMC: {
    ranks: [
      'Gen',
      'LtGen',
      'MajGen',
      'BGen',
      'Col',
      'LtCol',
      'Maj',
      'Capt',
      '1stLt',
      '2ndLt',
      'CWO5',
      'CWO4',
      'CWO3',
      'CWO2',
      'WO1',
    ],
    components: ['USMC', 'USMCR'],
  },
  USN: {
    ranks: [
      'ADM',
      'VADM',
      'RADM',
      'RDML',
      'CAPT',
      'CDR',
      'LCDR',
      'LT',
      'LTJG',
      'ENS',
      'CWO5',
      'CWO4',
      'CWO3',
      'CWO2',
      'WO1',
    ],
    components: ['USN', 'USNR'],
  },
  USPHS: {
    ranks: [
      'ADM',
      'VADM',
      'RADM',
      'RADM',
      'CAPT',
      'CDR',
      'LCDR',
      'LT',
      'LTJG',
      'ENS',
      'CWO5',
      'CWO4',
      'CWO3',
      'CWO2',
      'WO1',
      'SGEN',
      'DSG',
      'ASG',
      'DIR',
      'SR',
      'SR',
      'SR',
      'FULL',
      'FULL',
      'SAST',
      'AST',
    ],
    components: ['USPHS', 'USPHSR']
  }
}